import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Modal } from "../../Modal";
import { ModalContentContainer } from "../../ModalContentContainer";
import { StageActionEnum } from "../../../shared";
import { useAppDispatch, useAppSelector } from "../../../hooks";
import { dailyExerciseApi } from "../../../store/services";
import { showNotification } from "../../../store/reducers";
import { Button } from "../../Buttons";

import styles from "./longTermInactive.module.scss";

export const LongTermInactiveDialog = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const currentUser = useAppSelector(
    ({ userReducer }) => userReducer.currentUser,
  );

  const [isOpen, setIsOpen] = useState(false);
  const [openConfirmReturnToStart, setOpenConfirmReturnToStart] =
    useState(false);

  useEffect(() => {
    if (currentUser?.pendingToChooseStageAction) {
      setIsOpen(true);
    } else {
      setIsOpen(false);
      setOpenConfirmReturnToStart(false);
    }
  }, [currentUser?.pendingToChooseStageAction]);

  const [processStageAction, { isLoading }] =
    dailyExerciseApi.useProcessStageActionByPatientMutation();

  const handleError = (error: any) => {
    dispatch(
      showNotification({
        type: "error",
        message: t([
          `alert.errors.${error.data.message}`,
          `alert.somethingWentWrong`,
        ]),
      }),
    );
  };

  const onHandleContinueExercises = async () => {
    try {
      await processStageAction({ action: StageActionEnum.none }).unwrap();
      dispatch(
        showNotification({
          type: "success",
          message: t("alert.continueExercisesSuccess"),
        }),
      );
      setIsOpen(false);
    } catch (error: any) {
      handleError(error);
    }
  };

  const onHandleConfirm = async () => {
    try {
      await processStageAction({ action: StageActionEnum.reset }).unwrap();
      dispatch(
        showNotification({
          type: "success",
          message: t("alert.returnToStartSuccess"),
        }),
      );
      setIsOpen(false);
      setOpenConfirmReturnToStart(false);
    } catch (error: any) {
      handleError(error);
    }
  };

  return (
    <>
      <Modal
        isOpen={isOpen}
        customStyles={styles.longTermInactiveModal}
        blockClose
      >
        <ModalContentContainer
          modalTitle={t("longTermInactive.title")}
          subtitle={t("longTermInactive.subtitle")}
          customStyles={styles.longTermInactiveModalContent}
        >
          <Button
            label={t("buttons.continueExercises")}
            className="green_outlined"
            customStyle={styles.longTermContinueButton}
            onClick={onHandleContinueExercises}
            disabled={isLoading}
          />
          <Button
            label={t("buttons.returnToStart")}
            className="small_green"
            customStyle={styles.longTermContinueButton}
            onClick={() => setOpenConfirmReturnToStart(true)}
            disabled={isLoading}
          />
        </ModalContentContainer>
      </Modal>
      <Modal
        isOpen={openConfirmReturnToStart}
        customStyles={styles.longTermInactiveModal}
        blockClose
      >
        <ModalContentContainer
          modalTitle={t("longTermInactive.approvalTitle")}
          subtitle={t("longTermInactive.approvalSubtitle")}
          customStyles={styles.longTermInactiveModalContent}
        >
          <Button
            label={t("confirmModal.confirm")}
            className="small_green"
            customStyle={styles.longTermContinueButton}
            onClick={onHandleConfirm}
            disabled={isLoading}
          />
          <Button
            label={t("confirmModal.cancel")}
            className="orange_outlined"
            customStyle={styles.longTermContinueButton}
            onClick={() => setOpenConfirmReturnToStart(false)}
            disabled={isLoading}
          />
        </ModalContentContainer>
      </Modal>
    </>
  );
};
